(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Customer-Reviews-Two"] && !Shopify.designMode) return;
  try {
    
$(function () {
  var maxL = 80;

  $('.CR_readmoress p').each(function () {
    if ($(this).data('processed')) return;
    $(this).data('processed', true);

    var text = $(this).text().trim();
    if (text.length <= maxL) return;

    var begin = text.substr(0, maxL);
    var end = text.substr(maxL);

    $(this)
      .html('<span class="short-text">' + begin + '</span>')
      .append('<span class="hidden-text">' + end + '</span>')
      .append('<a class="readmore" href="javascript:void(0)"></a>');
  });

  $(document).on('click', '.readmore', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $btn = $(this);
    var $p = $btn.closest('p');
    var $hidden = $p.find('.hidden-text');

    $p.toggleClass('expanded');

    if ($p.hasClass('expanded')) {
      $hidden.stop(true, true).slideDown(300).fadeIn(200);
      $btn.text(' Read less');
    } else {
      $hidden.stop(true, true).slideUp(300);
      $btn.text(' Read more');
    }
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Explore-Best-Seller"] && !Shopify.designMode) return;
  try {
    
$(function() { 
  const swiper = new Swiper('.e-bike-pages-slider', {
    loop: true,
    speed: 1500,
    spaceBetween: 20,

    slidesPerView: 3,

    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1.4,
        spaceBetween: 15
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Find-Your-Perfect-Pick"] && !Shopify.designMode) return;
  try {
    

  if ($(window).width() <= 768) {
    $(function() {
      $(".filter-item:not(.item-1, .item-2) ul").css("display", "none");
      $(".filter-item.item-1 h3").addClass("open");
      $(".filter-item.item-2 h3").addClass("open");
      $(".filter-item h3").click(function() {
        $(".open")
          .not(this)
          .removeClass("open")
          .next()
          .slideUp(300);
        $(this).toggleClass("open").next().slideToggle(300);
      });
    });
  };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-seller-new"] && !Shopify.designMode) return;
  try {
    
(function initBestSellerSwiper(){
  if (window.Swiper) {
    new Swiper('.slider-best-seller', {
      loop: true,
      speed: 800,
      slidesPerView: 2,
      spaceBetween: 0,
      autoplay: { delay: 3000, disableOnInteraction: false },
      observer: true,
      observeParents: true,
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      breakpoints: { 0: { slidesPerView: 1 }, 768: { slidesPerView: 2 } }
    });
  } else {
    setTimeout(initBestSellerSwiper, 60);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
$(function() { 
    $('.slider-best-seller').slick({
    slidesToShow: 1.5,
    slidesToScroll: 1,
    speed: 2000,
	centerPadding: '60px',
    dots: false,
    focusOnSelect: true,
    centerMode: false,
    arrows: true,
    swipe: true,
    swipeToSlide: true,
	nextArrow:`<button type='button' class='slick-next pull-right'><img class="hs-lazyload hs-id-2c4ae034" loading="lazy" src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/right-arrow_99324b41-b1e9-45c8-95ca-a3dc54eb8098.png?v=1653551286"/></button>`,
    responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
		centerPadding: '0px',
        dots: true
      }
    }
  ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["e-bike-filter"] && !Shopify.designMode) return;
  try {
    

if($(window).width() <= 768){ 
$(function () {
  $(".filter-item:not(.item-1, .item-2) ul").css("display", "none");
  $(".filter-item.item-1 h3").addClass("open");
  $(".filter-item.item-2 h3").addClass("open");
  $(".filter-item h3").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});
};

let battry_type = '';
let range = '';
let terrain = '';
  
$(function() {
    $('input:radio[name="battery"]').change(function() {
        battry_type = $(this).val();
        updateUiGrids();
    });
    $('input:radio[name="Range"]').change(function() {
        range = 'Range_'+$(this).val();
        updateUiGrids();
    });
    $('input:radio[name="terrain"]').change(function() {
        terrain = $(this).val();
        updateUiGrids();
    });
});

function updateUiGrids(val){
  let ebikeProductFilter = document.querySelector(".ebike-product-filter");
  let productGrids = document.querySelectorAll(".grid-product-top-gcs");
  let showSection = false;
  productGrids.forEach(function(item,i){
    item.style.display = "none";
    if((item.getAttribute("data-tags")).includes(battry_type)&&(item.getAttribute("data-tags")).includes(range)&&(item.getAttribute("data-tags")).includes(terrain)){
      item.style.display = "block";
      showSection = true;
    }
  })
  if(showSection){
    ebikeProductFilter.style.display = "block";
  }else{
    ebikeProductFilter.style.display = "none";
  }
}

$(document).ready(function(){
  $('.offer-heading').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 500,
    draggable: true,
    infinite: true,
    autoplaySpeed: 3000,
    autoplay: true,
    cssEase: 'linear',
  });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gcs-testimonials"] && !Shopify.designMode) return;
  try {
    
$(function() { 
    $('.testimonial-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    focusOnSelect: true,
    centerMode: false,
    arrows: true,
    prevArrow:`<button type='button' class='slick-prev pull-left'><img class="hs-lazyload hs-id-a468f594" loading="lazy" src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/left-arrow.png?v=1652880489"/></button>`,
    nextArrow:`<button type='button' class='slick-next pull-right'><img class="hs-lazyload hs-id-9e5d8592" loading="lazy" src="https://cdn.shopify.com/s/files/1/0565/3404/0773/files/right-arrow.png?v=1652880488"/></button>`,
    swipe: true,
    swipeToSlide: true,
    responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    }
  ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper(".mySwiper", {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      speed: 2000,
      loop:true,
      autoplay: true,
      autoplaySpeed: 1000,
      adaptiveHeight: true,
      swipeToSlide: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },      
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wireframe-select-section"] && !Shopify.designMode) return;
  try {
    

$('ul.tabs li').click(function () {
var tab_id = $(this).attr('data-id');

$('ul.tabs li').removeClass('current');
$('.tab-content').removeClass('current');

$(this).addClass('current');
$("#gcs" + tab_id).addClass('current');
});
$(".gcs-cross").click(function(e){
  e.stopPropagation();
  $(".plus_icon").removeClass("plus_icon_addon");
  $('.gcs').attr("style","display:none;");
});

  } catch(e) { console.error(e); }
})();
})();
